import React, { Component } from 'react';
//import MaterialTable from 'material-table';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import Grid from '@material-ui/core/Grid';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { O_Mr } from './O_Mr';
import { O_Mq } from './O_Mq';
import { O_MonitoringNoteSupplies } from './O_MonitoringNoteSupplies';
import { O_MonitoringNoteWorks } from './O_MonitoringNoteWorks';
import { E_Mr } from './E_Mr';
import { E_Mq } from './E_Mq';
import { E_MonitoringNoteSupply } from './E_MonitoringNoteSupply';
import { E_MonitoringNoteWorks } from './E_MonitoringNoteWorks';

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//import HistoryIcon from '@material-ui/icons/History';
//import Typography from '@material-ui/core/Typography';
import AttachFileIcon from "@material-ui/icons/AttachFile";
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import CircularProgress from '@material-ui/core/CircularProgress';

import Modal from 'react-bootstrap/Modal';
import 'bootstrap/dist/css/bootstrap.min.css';

export class TemplateFillingPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            //projectList: [{ name: 'Proje 1', id: 1 }, { name: 'Proje 2', id: 2 }],
            typeOfROM: -1,
            templateList: [
                { TemplateName: "Ongoing MR", TemplateNumber: 1 },
                { TemplateName: "Expost MR", TemplateNumber: 2 },
                { TemplateName: "Ongoing MQ", TemplateNumber: 3 },
                { TemplateName: "Expost MQ", TemplateNumber: 4 },
                //{ TemplateName: "Supplies Ongoing", TemplateNumber: 5 },
                //{ TemplateName: "Supplies Expost", TemplateNumber: 6 },
                //{ TemplateName: "Works Ongoing", TemplateNumber: 7 },
                //{ TemplateName: "Works Expost", TemplateNumber: 8 },
                { TemplateName: "Monitoring Note for Supply Ongoing", TemplateNumber: 5 },
                { TemplateName: "Monitoring Note for Supply Expost", TemplateNumber: 6 },
                { TemplateName: "Monitoring Note for Works Ongoing", TemplateNumber: 7 },
                { TemplateName: "Monitoring Note for Works Expost", TemplateNumber: 8 },
            ],
            selectedTemplate: {},
            userType: -1,
            isTemplateFinished: 1,
            pageRevisions: [],
            pageData: {},
            notAuthorized: false,
            fileMR: "",
            fileMQ: "",
            fileNS: "",
            fileNW: "",
            fileRS: "",
            fileAdditional: "",

            filelabelnameMQ: "",
            filelabelnameMR: "",
            filelabelnameNS: "",
            filelabelnameNW: "",
            filelabelnameRS: "",
            filelabelnameAdditional: "",

            fileMRName: "",
            fileMQName: "",
            fileNSName: "",
            fileNWName: "",
            fileRSName: "",
            fileAdditionalName: "",

            fileMRPDF: "",
            fileMQPDF: "",
            fileNSPDF: "",
            fileNWPDF: "",
            fileRSPDF: "",
            fileAdditionalPDF: "",

            pageLoadData_O_Mr: {},
            pageLoadData_E_Mr: {},
            pageLoadData_O_Mq: {},
            pageLoadData_E_Mq: {},
            pageLoadData_O_MonitoringNoteSupplies: {},
            pageLoadData_E_MonitoringNoteSupply: {},
            pageLoadData_O_MonitoringNoteWorks: {},
            pageLoadData_E_MonitoringNoteWorks: {},

            isFetching: true,
            files: [],
            pageLastRevision: -1,
            isLoadingFinished: false,

            waitingMesagge: "Loading ...",
            waiting: true,
            loading: true,
            pageRevisions: [],
            pageMissionDetails: [],
            pageData: {},
            countOfRevision: 0,
            modalFinishOpen: false,
        };
    }

    componentDidMount = async () => {

        let pageTokenAuthData = {
            operation: "AuthCheckToken"
        };

        await fetch(global.variables.API_CHECKTOKEN, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageTokenAuthData)
        })
            .then(response => response.json())
            .then(result => {
                if (result.resultstate > 0 ||
                    result.authresp === 2) {
                    window.location.href = "/login";
                }
            }).catch(() => {
                window.location.href = "/login";
            });

        await this.loadPage();
        await this.getUserType();
        await this.loadMissionIsFinished();
        await this.getLastRevision();

        await this.loadRevision();

        await this.setState({ isFetching: false });

        await this.setState({ isLoadingFinished: true });
    };

    handleDoMissionFinish = async () => {

        await this.setModalFinishOpenToggle();

        //await this.handleFinishMission();
        await this.handleFinishTemplate();

        //window.location.reload();
    }

    checkAllFieldsFilled = (dataobj, fields) => {

        var omrFields = [];

        var omqFields = ["OmqQ01Does", "OmqQ02Does", "OmqQ03Is", "OmqQ04Is", "OmqQ05Do", "OmqQ06Do", "OmqQ07Is",
            "OmqQ08Is", "OmqQ09Are", "OmqQ10Are", "OmqQ11Have", "OmqQ12Have", "OmqQ13Are", "OmqQ14Are",
            "OmqQ15Are", "OmqQ16Are", "OmqQ17Are", "OmqQ18Are", "OmqQ19Were", "OmqQ20Were", "OmqQ21Are",
            "OmqQ22Are", "OmqConclusion1Relevance", "OmqQ23Have", "OmqQ24Have", "OmqQ25Do", "OmqQ26Do",
            "OmqQ27Do", "OmqQ28Do", "OmqQ29To", "OmqQ30To", "OmqQ31To", "OmqQ32To", "OmqQ33If", "OmqQ34If",
            "OmqQ35What", "OmqQ36What", "OmqQ37To", "OmqQ38To", "OmqQ39Are", "OmqQ40Are", "OmqQ41Is",
            "OmqQ42Is", "OmqConclusion2Efficiency", "OmqQ43Is", "OmqQ44Is", "OmqQ45Is", "OmqQ46Is",
            "OmqQ47Are", "OmqQ48Are", "OmqQ49Does", "OmqQ50Does", "OmqConclusion3Effectiveness", "OmqQ51Are",
            "OmqQ52Are", "OmqQ53Has", "OmqQ54Has", "OmqQ55Is", "OmqQ56Is", "OmqQ57Have", "OmqQ58Have",
            "OmqQ61Has", "OmqQ62Has", "OmqQ63Have", "OmqQ64Have", "OmqQ65Have", "OmqQ66Have",
            "OmqConclusion4Sustainability", "OmqQ68Have", "OmqQ70Have", "OmqQ72Are", "OmqC1Country",
            "OmqC2ProjectDocuments", "OmqC3QSG", "OmqC4FinancingContribution", "OmqC5ProjectContracts",
            "OmqC6InCaseOf", "OmqC7Riders", "OmqC8Annual", "OmqC9Implementation", "OmqC10PreviousROM",
            "OmqC11MidtermEvaluation", "OmqC12FinalEvaluations", "OmqC13ThematicStudies", "OmqOtherDocumentsD1",
            "OmqSOIP1PersonCategory", "OmqSOIP1PersonName", "OmqSOIP1PersonEmail", "OmqSOIP1PersonPosition",
            "OmqSOIP1PersonInstitution"];

        var emqFields = ["EmqQ1Didthe", "EmqQ2Didthe", "EmqQ3Hasthe", "EmqQ4Hasthe", "EmqQ5Havethe",
            "EmqQ6Havethe", "EmqQ7Hasthere", "EmqQ8Hasthere", "EmqQ9Havethere", "EmqQ10Havethere",
            "EmqQ11Hasan", "EmqQ12Hasan", "EmqQ13Werethe", "EmqQ14Werethe", "EmqQ15Hasall", "EmqQ16Hasall",
            "EmqQ17Havethe", "EmqQ18Havethe", "EmqQ19Were", "EmqQ20Were", "EmqQ21Were", "EmqQ22Were",
            "EmqConclusion1Relevance", "EmqQ23Have", "EmqQ24Have", "EmqQ25Have", "EmqQ26Have", "EmqQ27Inputs",
            "EmqQ28Inputs", "EmqQ29What", "EmqQ30What", "EmqQ31Towhat", "EmqQ32Towhat", "EmqQ33Delays",
            "EmqQ34Delays", "EmqQ35Were", "EmqQ36Were", "EmqQ37Wasthe", "EmqQ38Wasthe", "EmqConclusion2Efficiency",
            "EmqQ39Hasthe", "EmqQ40Hasthe", "EmqQ41Hasthe", "EmqQ42Hasthe", "EmqQ43Towhat", "EmqQ44Towhat",
            "EmqQ45Didthe", "EmqQ46Didthe", "EmqConclusion3Effectiveness", "EmqQ47Hasthere", "EmqQ48Hasthere",
            "EmqQ49Towhat", "EmqQ50Towhat", "EmqQ51Towhat", "EmqQ52Towhat", "EmqConclusion4Impact", "EmqQ53Hasthe",
            "EmqQ54Hasthe", "EmqQ55Hasthe", "EmqQ56Hasthe", "EmqQ57Haveaccess", "EmqQ58Haveaccess", "EmqQ59Havethe",
            "EmqQ60Havethe", "EmqQ61Towhat", "EmqQ62Towhat", "EmqQ63Havethe", "EmqQ64Havethe", "EmqQ65Havethe",
            "EmqQ66Havethe", "EmqLessonsLearnt", "EmqQ68Hasthe", "EmqQ69Havethe",
            "EmqQ70Werethere", "EmqC1Country", "EmqC2ProjectDocuments", "EmqC3QSG", "EmqC4FinancingContribution",
            "EmqC5ProjectContracts", "EmqC6InCaseOf", "EmqC7Riders", "EmqC8Annual", "EmqC9Implementation", "EmqC10PreviousROM",
            "EmqC11MidtermEvaluation", "EmqC12FinalEvaluations", "EmqC13ThematicStudies", "EmqOtherDocumentsD1",
            "EmqSOIP1PersonCategory", "EmqSOIP1PersonName", "EmqSOIP1PersonEmail", "EmqSOIP1PersonPosition",
            "EmqSOIP1PersonInstitution"];

        var omonitoringnotesuppliesFields = ["OmsS1Relevance", "OmsS2Efficiency", "OmsS3Effectiveness",
            "OmsS5Sustainability", "OmsQ1Are", "OmsQ2Is", "OmsQ3Define", "OmsQ17Have", "OmsQ4Are",
            "OmsQ5Does", "OmsQ7Has", "OmsQ8What", "OmsQ9How", "OmsQ10Are", "OmsQ11Is", "OmsQ12Have",
            "OmsQ13Has", "OmsQ14Have", "OmsQ15Have", "OmsQ16Is", "OmsC1ProjectDocuments",
            "OmsC2FinancingContribution", "OmsC3Riders", "OmsC4Annual", "OmsC5Implementation",
            "OmsOtherDocumentsD1", "OmsSOIP1PersonCategory", "OmsSOIP1PersonName", "OmsSOIP1PersonEmail",
            "OmsSOIP1PersonPosition", "OmsSOIP1PersonInstitution"];

        var emonitoringnotesupplyFields = ["EmsS1Relevance", "EmsS2Efficiency", "EmsS3Effectiveness",
            "EmsS4Impact", "EmsS5Sustainability", "EmsQ1Were", "EmsQ2Was", "EmsQ3Define", "EmsQ4Were",
            "EmsQ5Have", "EmsQ6Did", "EmsQ7Was", "EmsQ8What", "EmsQ9How", "EmsQ10Identify", "EmsQ11What",
            "EmsQ12Has", "EmsQ13Did", "EmsQ14Are", "EmsQ15Has", "EmsQ16Has", "EmsQ17Have", "EmsQ19Have",
            "EmsQ20Was", "EmsC1ProjectDocuments", "EmsC2FinancingContribution", "EmsC3Riders", "EmsC4Annual",
            "EmsC5Implementation", "EmsOtherDocumentsD1", "EmsSOIP1PersonCategory", "EmsSOIP1PersonName",
            "EmsSOIP1PersonEmail", "EmsSOIP1PersonPosition", "EmsSOIP1PersonInstitution"];

        var omonitoringnoteworksFields = ["OmwS1Relevance", "OmwS2Efficiency", "OmwS3Effectiveness",
            "OmwS5Sustainability", "OmwQ1Are", "OmwQ2Is", "OmwQ3Define", "OmwQ4Are", "OmwQ4Are2", "OmwQ5Does",
            "OmwQ6Has", "OmwQ7What", "OmwQ8How", "OmwQ9Are", "OmwQ10Is", "OmwQ11Have", "OmwQ12Has", "OmwQ13Have",
            "OmwQ14Have", "OmwQ15Is", "OmwC1ProjectDocuments", "OmwC2FinancingContribution", "OmwC3Riders",
            "OmwC4Annual", "OmwC5Implementation", "OmwOtherDocumentsD1", "OmwSOIP1PersonCategory", "OmwSOIP1PersonName",
            "OmwSOIP1PersonEmail", "OmwSOIP1PersonPosition", "OmwSOIP1PersonInstitution"];

        var emonitoringnoteworksFields = ["EmwS1Relevance", "EmwS2Efficiency", "EmwS3Effectiveness", "EmwS4Impact",
            "EmwS5Sustainability", "EmwQ1Were", "EmwQ2Was", "EmwQ3Define", "EmwQ4Were", "EmwQ5Have", "EmwQ6Did",
            "EmwQ7Was", "EmwQ8What", "EmwQ9How", "EmwQ10Identify", "EmwQ11What", "EmwQ12Has", "EmwQ13Did", "EmwQ14Are",
            "EmwQ15Has", "EmwQ16Has", "EmwQ17Have", "EmwQ18Have", "EmwQ19Was", "EmwC1ProjectDocuments",
            "EmwC2FinancingContribution", "EmwC3Riders", "EmwC4Annual", "EmwC5Implementation", "EmwOtherDocumentsD1",
            "EmwSOIP1PersonCategory", "EmwSOIP1PersonName", "EmwSOIP1PersonEmail", "EmwSOIP1PersonPosition",
            "EmwSOIP1PersonInstitution"];

        var fieldsname = [];

        if (fields == "omq") {
            fieldsname = omqFields;
        } else if (fields == "emq") {
            fieldsname = emqFields;
        } else if (fields == "omonitoringnotesupplies") {
            fieldsname = omonitoringnotesuppliesFields;
        } else if (fields == "emonitoringnotesupply") {
            fieldsname = emonitoringnotesupplyFields;
        } else if (fields == "omonitoringnoteworks") {
            fieldsname = omonitoringnoteworksFields;
        } else if (fields == "emonitoringnoteworks") {
            fieldsname = emonitoringnoteworksFields;
        }

        for (let i = 0; i < fieldsname.length; i++) {
            if (dataobj[fieldsname[i]] == null ||
                dataobj[fieldsname[i]] == "undefined" ||
                dataobj[fieldsname[i]] == "" ||
                dataobj[fieldsname[i]] == " ") {

                console.log(fieldsname[i]);

                return false;
                break;
            }
        }

        return true;
    }

    toastMessageFillAll = async () => {
        await toast.error("Please fill in all fields!", {
            position: toast.POSITION.BOTTOM_RIGHT
        });
    }

    handleMissionFinishConfirmation = async (val) => {

        // Check if all fields are filled

        if (this.state.selectedTemplate !== null && this.state.selectedTemplate.TemplateNumber === 1) {
            // O_Mr

            console.log("O_Mr");
            console.log(this.state.pageLoadData_O_Mr);

            if ((this.state.pageLoadData_O_Mr.OmrS1Relevance == null ||
                this.state.pageLoadData_O_Mr.OmrS1Relevance == "undefined" ||
                this.state.pageLoadData_O_Mr.OmrS1Relevance == "" ||
                this.state.pageLoadData_O_Mr.OmrS1Relevance == " ") ||

                (this.state.pageLoadData_O_Mr.OmrS2Efficiency == null ||
                    this.state.pageLoadData_O_Mr.OmrS2Efficiency == "undefined" ||
                    this.state.pageLoadData_O_Mr.OmrS2Efficiency == "" ||
                    this.state.pageLoadData_O_Mr.OmrS2Efficiency == " ") ||

                (this.state.pageLoadData_O_Mr.OmrS3Effectiveness == null ||
                    this.state.pageLoadData_O_Mr.OmrS3Effectiveness == "undefined" ||
                    this.state.pageLoadData_O_Mr.OmrS3Effectiveness == "" ||
                    this.state.pageLoadData_O_Mr.OmrS3Effectiveness == " ") ||

                (this.state.pageLoadData_O_Mr.OmrS5Sustainability == null ||
                    this.state.pageLoadData_O_Mr.OmrS5Sustainability == "undefined" ||
                    this.state.pageLoadData_O_Mr.OmrS5Sustainability == "" ||
                    this.state.pageLoadData_O_Mr.OmrS5Sustainability == " ") ||

                (this.state.pageLoadData_O_Mr.OmrQ1Context == null ||
                    this.state.pageLoadData_O_Mr.OmrQ1Context == "undefined" ||
                    this.state.pageLoadData_O_Mr.OmrQ1Context == "" ||
                    this.state.pageLoadData_O_Mr.OmrQ1Context == " ") ||

                (this.state.pageLoadData_O_Mr.OmrQ2Description == null ||
                    this.state.pageLoadData_O_Mr.OmrQ2Description == "undefined" ||
                    this.state.pageLoadData_O_Mr.OmrQ2Description == "" ||
                    this.state.pageLoadData_O_Mr.OmrQ2Description == " ") ||

                (this.state.pageLoadData_O_Mr.OmrQ3Relevance == null ||
                    this.state.pageLoadData_O_Mr.OmrQ3Relevance == "undefined" ||
                    this.state.pageLoadData_O_Mr.OmrQ3Relevance == "" ||
                    this.state.pageLoadData_O_Mr.OmrQ3Relevance == " ") ||

                (this.state.pageLoadData_O_Mr.OmrQ4Efficiency == null ||
                    this.state.pageLoadData_O_Mr.OmrQ4Efficiency == "undefined" ||
                    this.state.pageLoadData_O_Mr.OmrQ4Efficiency == "" ||
                    this.state.pageLoadData_O_Mr.OmrQ4Efficiency == " ") ||

                (this.state.pageLoadData_O_Mr.OmrQ5Effectiveness == null ||
                    this.state.pageLoadData_O_Mr.OmrQ5Effectiveness == "undefined" ||
                    this.state.pageLoadData_O_Mr.OmrQ5Effectiveness == "" ||
                    this.state.pageLoadData_O_Mr.OmrQ5Effectiveness == " ") ||

                (this.state.pageLoadData_O_Mr.OmrQ6Sustainability == null ||
                    this.state.pageLoadData_O_Mr.OmrQ6Sustainability == "undefined" ||
                    this.state.pageLoadData_O_Mr.OmrQ6Sustainability == "" ||
                    this.state.pageLoadData_O_Mr.OmrQ6Sustainability == " ") ||

                (this.state.pageLoadData_O_Mr.OmrQ7ConclusionsC1 == null ||
                    this.state.pageLoadData_O_Mr.OmrQ7ConclusionsC1 == "undefined" ||
                    this.state.pageLoadData_O_Mr.OmrQ7ConclusionsC1 == "" ||
                    this.state.pageLoadData_O_Mr.OmrQ7ConclusionsC1 == " ") ||

                (this.state.pageLoadData_O_Mr.OmrQ8Recommendations == null ||
                    this.state.pageLoadData_O_Mr.OmrQ8Recommendations == "undefined" ||
                    this.state.pageLoadData_O_Mr.OmrQ8Recommendations == "" ||
                    this.state.pageLoadData_O_Mr.OmrQ8Recommendations == " ")

                //||

                //this.state.pageLoadData_O_Mr.countConclusions == 0 ||
                //this.state.pageLoadData_O_Mr.countRecommendations == 0
            ) {

                this.toastMessageFillAll();
            } else {
                await this.setModalFinishOpenToggle();
            }
        }

        if (this.state.selectedTemplate !== null && this.state.selectedTemplate.TemplateNumber === 2) {
            // E_Mr

            console.log("E_Mr");
            console.log(this.state.pageLoadData_E_Mr);

            if ((this.state.pageLoadData_E_Mr.EmrS1Relevance == null ||
                this.state.pageLoadData_E_Mr.EmrS1Relevance == "undefined" ||
                this.state.pageLoadData_E_Mr.EmrS1Relevance == "" ||
                this.state.pageLoadData_E_Mr.EmrS1Relevance == " ") ||

                (this.state.pageLoadData_E_Mr.EmrS2Efficiency == null ||
                    this.state.pageLoadData_E_Mr.EmrS2Efficiency == "undefined" ||
                    this.state.pageLoadData_E_Mr.EmrS2Efficiency == "" ||
                    this.state.pageLoadData_E_Mr.EmrS2Efficiency == " ") ||

                (this.state.pageLoadData_E_Mr.EmrS3Effectiveness == null ||
                    this.state.pageLoadData_E_Mr.EmrS3Effectiveness == "undefined" ||
                    this.state.pageLoadData_E_Mr.EmrS3Effectiveness == "" ||
                    this.state.pageLoadData_E_Mr.EmrS3Effectiveness == " ") ||

                (this.state.pageLoadData_E_Mr.EmrS4Impact == null ||
                    this.state.pageLoadData_E_Mr.EmrS4Impact == "undefined" ||
                    this.state.pageLoadData_E_Mr.EmrS4Impact == "" ||
                    this.state.pageLoadData_E_Mr.EmrS4Impact == " ") ||

                (this.state.pageLoadData_E_Mr.EmrS5Sustainability == null ||
                    this.state.pageLoadData_E_Mr.EmrS5Sustainability == "undefined" ||
                    this.state.pageLoadData_E_Mr.EmrS5Sustainability == "" ||
                    this.state.pageLoadData_E_Mr.EmrS5Sustainability == " ") ||

                (this.state.pageLoadData_E_Mr.EmrQ1Context == null ||
                    this.state.pageLoadData_E_Mr.EmrQ1Context == "undefined" ||
                    this.state.pageLoadData_E_Mr.EmrQ1Context == "" ||
                    this.state.pageLoadData_E_Mr.EmrQ1Context == " ") ||

                (this.state.pageLoadData_E_Mr.EmrQ2Description == null ||
                    this.state.pageLoadData_E_Mr.EmrQ2Description == "undefined" ||
                    this.state.pageLoadData_E_Mr.EmrQ2Description == "" ||
                    this.state.pageLoadData_E_Mr.EmrQ2Description == " ") ||

                (this.state.pageLoadData_E_Mr.EmrQ3Relevance == null ||
                    this.state.pageLoadData_E_Mr.EmrQ3Relevance == "undefined" ||
                    this.state.pageLoadData_E_Mr.EmrQ3Relevance == "" ||
                    this.state.pageLoadData_E_Mr.EmrQ3Relevance == " ") ||

                (this.state.pageLoadData_E_Mr.EmrQ4Efficiency == null ||
                    this.state.pageLoadData_E_Mr.EmrQ4Efficiency == "undefined" ||
                    this.state.pageLoadData_E_Mr.EmrQ4Efficiency == "" ||
                    this.state.pageLoadData_E_Mr.EmrQ4Efficiency == " ") ||

                (this.state.pageLoadData_E_Mr.EmrQ5Effectiveness == null ||
                    this.state.pageLoadData_E_Mr.EmrQ5Effectiveness == "undefined" ||
                    this.state.pageLoadData_E_Mr.EmrQ5Effectiveness == "" ||
                    this.state.pageLoadData_E_Mr.EmrQ5Effectiveness == " ") ||

                (this.state.pageLoadData_E_Mr.EmrQ6Impact == null ||
                    this.state.pageLoadData_E_Mr.EmrQ6Impact == "undefined" ||
                    this.state.pageLoadData_E_Mr.EmrQ6Impact == "" ||
                    this.state.pageLoadData_E_Mr.EmrQ6Impact == " ") ||

                (this.state.pageLoadData_E_Mr.EmrQ7Sustainability == null ||
                    this.state.pageLoadData_E_Mr.EmrQ7Sustainability == "undefined" ||
                    this.state.pageLoadData_E_Mr.EmrQ7Sustainability == "" ||
                    this.state.pageLoadData_E_Mr.EmrQ7Sustainability == " ") ||

                (this.state.pageLoadData_E_Mr.EmrQ8ConclusionC1 == null ||
                    this.state.pageLoadData_E_Mr.EmrQ8ConclusionC1 == "undefined" ||
                    this.state.pageLoadData_E_Mr.EmrQ8ConclusionC1 == "" ||
                    this.state.pageLoadData_E_Mr.EmrQ8ConclusionC1 == " ") ||

                (this.state.pageLoadData_E_Mr.EmrQ10Lesson == null ||
                    this.state.pageLoadData_E_Mr.EmrQ10Lesson == "undefined" ||
                    this.state.pageLoadData_E_Mr.EmrQ10Lesson == "" ||
                    this.state.pageLoadData_E_Mr.EmrQ10Lesson == " ")

                //||

                //this.state.pageLoadData_E_Mr.countConclusions == 0 ||
                //this.state.pageLoadData_E_Mr.countLessonsLearnt == 0
            ) {

                this.toastMessageFillAll();
            } else {
                await this.setModalFinishOpenToggle();
            }
        }

        if (this.state.selectedTemplate !== null && this.state.selectedTemplate.TemplateNumber === 3) {
            // O_Mq

            console.log("O_Mq");
            console.log(this.state.pageLoadData_O_Mq);

            if (!this.checkAllFieldsFilled(this.state.pageLoadData_O_Mq, "omq")
                //||
                //this.state.pageLoadData_O_Mq.countOtherDocuments == 0 ||
                //this.state.pageLoadData_O_Mq.countPerson == 0
            ) {

                this.toastMessageFillAll();
            } else {
                await this.setModalFinishOpenToggle();
            }

            //if ((this.state.pageLoadData_O_Mq.OmrS1Relevance == null ||
            //    this.state.pageLoadData_O_Mq.OmrS1Relevance == "undefined" ||
            //    this.state.pageLoadData_O_Mq.OmrS1Relevance == "" ||
            //    this.state.pageLoadData_O_Mq.OmrS1Relevance == " ") ||

            //    (this.state.pageLoadData_O_Mq.OmrQ7ConclusionsC1 == null ||
            //        this.state.pageLoadData_O_Mq.OmrQ7ConclusionsC1 == "undefined" ||
            //        this.state.pageLoadData_O_Mq.OmrQ7ConclusionsC1 == "" ||
            //        this.state.pageLoadData_O_Mq.OmrQ7ConclusionsC1 == " ") ||

            //    (this.state.pageLoadData_O_Mq.OmrQ8Recommendations == null ||
            //        this.state.pageLoadData_O_Mq.OmrQ8Recommendations == "undefined" ||
            //        this.state.pageLoadData_O_Mq.OmrQ8Recommendations == "" ||
            //        this.state.pageLoadData_O_Mq.OmrQ8Recommendations == " ") ||

            //    this.state.pageLoadData_O_Mq.countConclusions == 0 ||
            //    this.state.pageLoadData_O_Mq.countRecommendations == 0) {

            //    this.toastMessageFillAll();
            //} else {
            //    await this.setModalFinishOpenToggle();
            //}
        }

        if (this.state.selectedTemplate !== null && this.state.selectedTemplate.TemplateNumber === 4) {
            // E_Mq

            console.log("E_Mq");
            console.log(this.state.pageLoadData_E_Mq);

            if (!this.checkAllFieldsFilled(this.state.pageLoadData_E_Mq, "emq")
                //||
                //this.state.pageLoadData_E_Mq.countOtherDocuments == 0 ||
                //this.state.pageLoadData_E_Mq.countPerson == 0
            ) {

                this.toastMessageFillAll();
            } else {
                await this.setModalFinishOpenToggle();
            }
        }

        if (this.state.selectedTemplate !== null && this.state.selectedTemplate.TemplateNumber === 5) {
            // O_MonitoringNoteSupplies

            console.log("O_MonitoringNoteSupplies");
            console.log(this.state.pageLoadData_O_MonitoringNoteSupplies);

            if (!this.checkAllFieldsFilled(this.state.pageLoadData_O_MonitoringNoteSupplies, "omonitoringnotesupplies")) {

                this.toastMessageFillAll();
            } else {
                await this.setModalFinishOpenToggle();
            }
        }

        if (this.state.selectedTemplate !== null && this.state.selectedTemplate.TemplateNumber === 6) {
            // E_MonitoringNoteSupply

            console.log("E_MonitoringNoteSupply");
            console.log(this.state.pageLoadData_E_MonitoringNoteSupply);

            if (!this.checkAllFieldsFilled(this.state.pageLoadData_E_MonitoringNoteSupply, "emonitoringnotesupply")) {

                this.toastMessageFillAll();
            } else {
                await this.setModalFinishOpenToggle();
            }
        }

        if (this.state.selectedTemplate !== null && this.state.selectedTemplate.TemplateNumber === 7) {
            // O_MonitoringNoteWorks

            console.log("O_MonitoringNoteWorks");
            console.log(this.state.pageLoadData_O_MonitoringNoteWorks);

            if (!this.checkAllFieldsFilled(this.state.pageLoadData_O_MonitoringNoteWorks, "omonitoringnoteworks")) {

                this.toastMessageFillAll();
            } else {
                await this.setModalFinishOpenToggle();
            }
        }

        if (this.state.selectedTemplate !== null && this.state.selectedTemplate.TemplateNumber === 8) {
            // E_MonitoringNoteWorks

            console.log("E_MonitoringNoteWorks");
            console.log(this.state.pageLoadData_E_MonitoringNoteWorks);

            if (!this.checkAllFieldsFilled(this.state.pageLoadData_E_MonitoringNoteWorks, "emonitoringnoteworks")) {

                this.toastMessageFillAll();
            } else {
                await this.setModalFinishOpenToggle();
            }
        }

        //await this.setModalFinishOpenToggle();
    }

    setModalFinishOpenToggle = async () => {
        await this.setState({ modalFinishOpen: !this.state.modalFinishOpen });
    }

    getUserType = () => {
        let pageData = {
            operation: "GetUserType"
        };

        fetch(global.variables.API_USEROPERATIONS_GETUSERTYPE, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({ userType: result.userType });
            });
    }

    getLastRevision = async () => {
        let pageData = {
            missionId: this.props.match.params.id
        }

        await fetch(global.variables.API_REPORTCYCLE_GETLASTREVISION, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 2) {
                    this.setState({ notAuthorized: true });
                } else {
                    this.setState({
                        pageRevisions: result.revisions,
                        pageLastRevision: result.revisions[0].revisionType,
                        pageData: result,
                        fileMR: result.revisions[0].fileMR,
                        fileMQ: result.revisions[0].fileMQ,
                        fileNS: result.revisions[0].fileNS,
                        fileNW: result.revisions[0].fileNW,
                        fileRS: result.revisions[0].fileRS,
                        fileAdditional: result.revisions[0].fileAdditional,
                        fileMRName: result.revisions[0].fileMRName,
                        fileMQName: result.revisions[0].fileMQName,
                        fileNSName: result.revisions[0].fileNSName,
                        fileNWName: result.revisions[0].fileNWName,
                        fileRSName: result.revisions[0].fileRSName,
                        fileMRPDF: result.revisions[0].fileMRPDF,
                        fileMQPDF: result.revisions[0].fileMQPDF,
                        fileNSPDF: result.revisions[0].fileNSPDF,
                        fileNWPDF: result.revisions[0].fileNWPDF,
                        fileRSPDF: result.revisions[0].fileRSPDF,
                        fileAdditionalPDF: result.revisions[0].fileAdditionalPDF,
                    });

                    console.log("pageLastRevision " + result.revisions[0].revisionType);

                }
            });

        await this.forceUpdate();
    };

    loadPage = async () => {

        await this.setState({
            missionId: this.props.match.params.id
        });

        await fetch(global.variables.API_PROJECTDETAILS_GETTYPEOFROM, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({
                    typeOfROM: result.typeOfROM
                });

                if (result.typeOfROM === 1) {
                    this.setState({
                        templateList: [
                            { TemplateName: "Ongoing MR", TemplateNumber: 1 },
                            { TemplateName: "Ongoing MQ", TemplateNumber: 3 },
                        ]
                    });
                } else if (result.typeOfROM === 2) {
                    this.setState({
                        templateList: [
                            { TemplateName: "Expost MR", TemplateNumber: 2 },
                            { TemplateName: "Expost MQ", TemplateNumber: 4 },
                        ]
                    });
                } else if (result.typeOfROM === 3) {
                    this.setState({
                        templateList: [
                            //{ TemplateName: "Supplies Ongoing", TemplateNumber: 5 },
                            { TemplateName: "Monitoring Note for Supply Ongoing", TemplateNumber: 5 },
                        ]
                    });
                } else if (result.typeOfROM === 4) {
                    this.setState({
                        templateList: [
                            //{ TemplateName: "Supplies Expost", TemplateNumber: 6 },
                            { TemplateName: "Monitoring Note for Supply Expost", TemplateNumber: 6 },
                        ]
                    });
                } else if (result.typeOfROM === 5) {
                    this.setState({
                        templateList: [
                            //{ TemplateName: "Works Ongoing", TemplateNumber: 7 },
                            { TemplateName: "Monitoring Note for Works Ongoing", TemplateNumber: 7 },
                        ]
                    });
                } else if (result.typeOfROM === 6) {
                    this.setState({
                        templateList: [
                            //{ TemplateName: "Works Expost", TemplateNumber: 8 },
                            { TemplateName: "Monitoring Note for Works Expost", TemplateNumber: 8 },
                        ]
                    });
                } else {
                    this.setState({
                        templateList: [
                            { TemplateName: "Ongoing MR", TemplateNumber: 1 },
                            { TemplateName: "Expost MR", TemplateNumber: 2 },
                            { TemplateName: "Ongoing MQ", TemplateNumber: 3 },
                            { TemplateName: "Expost MQ", TemplateNumber: 4 },
                            //{ TemplateName: "Supplies Ongoing", TemplateNumber: 5 },
                            //{ TemplateName: "Supplies Expost", TemplateNumber: 6 },
                            //{ TemplateName: "Works Ongoing", TemplateNumber: 7 },
                            //{ TemplateName: "Works Expost", TemplateNumber: 8 },
                            { TemplateName: "Monitoring Note for Supply Ongoing", TemplateNumber: 5 },
                            { TemplateName: "Monitoring Note for Supply Expost", TemplateNumber: 6 },
                            { TemplateName: "Monitoring Note for Works Ongoing", TemplateNumber: 7 },
                            { TemplateName: "Monitoring Note for Works Expost", TemplateNumber: 8 },
                        ]
                    });
                }
            });
    }

    loadMissionIsFinished = () => {
        let pageData = {
            missionId: this.props.match.params.id
        };

        fetch(global.variables.API_PROJECTDETAILS_GETMISSIONTEMPLATESTATUS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({
                    isTemplateFinished: result.isTemplateFinished
                });
            });
    }

    loadRevision = async () => {
        await this.setState({
            loading: true,
            waitingMesagge: "Loading ..."
        });

        await fetch(global.variables.API_REPORTCYCLE_GETREVISION, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 2) {
                    this.setState({ notAuthorized: true });
                } else {

                    console.log("md: ");
                    console.log(result.missiondetails);

                    this.setState({
                        pageRevisions: result.revisions,
                        pageMissionDetails: result.missiondetails,
                        pageData: result
                    });

                    this.setState({
                        waitingMesagge: result.revisionWaitingMessage,
                        waiting: result.revisionIsWaiting,
                        isApprovedQC: result.isApprovedQC,
                        isApprovedQA: result.isApprovedQA
                    });

                    this.setState({
                        loading: false,
                        countOfRevision: result.revisions.length
                    });
                }
            });
    };

    handleTemplateChange = (e, v) => {
        e.persist();

        if (v !== undefined & v !== null) {
            this.setState({ selectedTemplate: v });
        } else {
            this.setState({ selectedTemplate: null });
        }

        //if (v !== undefined & v !== null) {
        //    this.setState({
        //        monuserid: v.idLoginCredentials,
        //        projectMonitor: v
        //    });
        //} else {
        //    this.setState({
        //        monuserid: -1,
        //        projectMonitor: null
        //    });
        //}
    }

    handleFinishTemplate = async () => {
        let pageData = {
            missionId: this.props.match.params.id
        };

        fetch(global.variables.API_PROJECTDETAILS_SETMISSIONTEMPLATEFINISHED, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }

                this.loadMissionIsFinished();
            });
    }

    handleFileInputChange = event => {
        var filesvar = this.state.files;
        filesvar.push({
            filename: event.target.name,
            fileblob: event.target.files[0]
        });
        this.setState({ files: filesvar });

        console.log("event.target.name " + event.target.name);

        if (event.target.name === "fileMQ") {
            this.setState({ filelabelnameMQ: event.target.files[0].name });
        }
        if (event.target.name === "fileMR") {
            this.setState({ filelabelnameMR: event.target.files[0].name });
        }
        if (event.target.name === "fileNS") {
            this.setState({ filelabelnameNS: event.target.files[0].name });
        }
        if (event.target.name === "fileNW") {
            this.setState({ filelabelnameNW: event.target.files[0].name });
        }
        if (event.target.name === "fileRS") {
            this.setState({ filelabelnameRS: event.target.files[0].name });
        }
        if (event.target.name === "fileAdditional") {
            this.setState({ filelabelnameAdditional: event.target.files[0].name });
        }
    };

    sendRevision = async (e) => {
        console.log("Send Revision");
        console.log(this.state);

        //return;

        await this.setState({ isFetching: true });

        var formData = new FormData();

        if (this.state.files && this.state.files.length > 0) {
            var filesarray = this.state.files;
            for (var i = 0; i < filesarray.length; i++) {
                //console.log("Appending files " + filesarray[i].filename);
                formData.append(filesarray[i].filename, filesarray[i].fileblob);
            }
        }

        var postData = this.state;
        Object.keys(postData).forEach((key, value) => {
            if (key !== "files") {
                formData.append(key, postData[key]);
            }
        });

        // This is for test fetch, URL will be changed
        await fetch(global.variables.API_REPORTCYCLE_SENDREVISION, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                //Accept: "application/json",
                //"Content-Type": "application/json"
            },
            body: formData
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }

                //this.pageLoad();
                this.getLastRevision();
            });

        await this.setState({ isFetching: false });
    };

    updatePageLoadData_O_Mr = async (data) => {
        await this.setState({ pageLoadData_O_Mr: data });
    }

    updatePageLoadData_E_Mr = async (data) => {
        await this.setState({ pageLoadData_E_Mr: data });
    }

    updatePageLoadData_O_Mq = async (data) => {
        await this.setState({ pageLoadData_O_Mq: data });
    }

    updatePageLoadData_E_Mq = async (data) => {
        await this.setState({ pageLoadData_E_Mq: data });
    }

    updatePageLoadData_O_MonitoringNoteSupplies = async (data) => {
        await this.setState({ pageLoadData_O_MonitoringNoteSupplies: data });
    }

    updatePageLoadData_E_MonitoringNoteSupply = async (data) => {
        await this.setState({ pageLoadData_E_MonitoringNoteSupply: data });
    }

    updatePageLoadData_O_MonitoringNoteWorks = async (data) => {
        await this.setState({ pageLoadData_O_MonitoringNoteWorks: data });
    }

    updatePageLoadData_E_MonitoringNoteWorks = async (data) => {
        await this.setState({ pageLoadData_E_MonitoringNoteWorks: data });
    }

    render() {

        //console.log("pageRevisions");
        //console.log(this.state.pageRevisions);
        //console.log(this.state.pageRevisions[0]);

        const {
            templateList,
            selectedTemplate,
            userType,
            isTemplateFinished,
            fileMR,
            fileMQ,
            fileNS,
            fileNW,
            fileRS,
            //fileAdditional,

            filelabelnameMQ,
            filelabelnameMR,
            filelabelnameNS,
            filelabelnameNW,
            filelabelnameRS,
            filelabelnameAdditional,

            fileMRName,
            fileMQName,
            fileNSName,
            fileNWName,
            fileRSName,
            //fileAdditionalName,

            fileMRPDF,
            fileMQPDF,
            fileNSPDF,
            fileNWPDF,
            fileRSPDF,
            //fileAdditionalPDF,

            isFetching,
            pageLastRevision,
            isLoadingFinished,
            modalFinishOpen,
        } = this.state;

        if (!isLoadingFinished) {
            return (
                <CircularProgress />
            );
        } else {

            if (userType !== 2 && userType !== 4) {
                return (
                    //<p>You are not authorized</p>
                    <p>QC & QA cycle is over, thank you for your efforts.</p>
                );
            } else {
                if (isTemplateFinished === 1) {
                    return (
                        <div>
                            <p>Mission saved and finished</p>

                            {
                                <Grid item xs={12}>
                                    <p>Project Title: {this.state.pageMissionDetails[0] != undefined ? this.state.pageMissionDetails[0].ProjectTitle : ""}</p>
                                    <p>Project Number: {this.state.pageMissionDetails[0] != undefined ? this.state.pageMissionDetails[0].ProjectNumber : ""}</p>
                                    <p>Mission Number: {this.state.pageMissionDetails[0] != undefined ? this.state.pageMissionDetails[0].MissionNumber : ""}</p>
                                </Grid>
                            }

                            <Grid container className="mt-1" spacing={6} >
                                <Grid xs={2} item>
                                    <Button variant="outlined" color="primary" href={"/api/FileUploadDownload/DownloadFileId/" + btoa(localStorage.getItem("authtoken")) + "/" + fileMR}
                                        download={fileMRName} fullWidth disabled={fileMR === "" ? true : false} style={{ textAlign: "center", height: 62 }}>
                                        MONITORING REPORT
                                </Button>
                                </Grid>
                                <Grid xs={1} item>
                                    <Button variant="outlined" color="primary" href={"/api/FileUploadDownload/DownloadFileIdWordAsPDF/" + btoa(localStorage.getItem("authtoken")) + "/" + fileMR}
                                        download={fileMRPDF} fullWidth disabled={fileMR === "" ? true : false}>
                                        PDF
                                </Button>
                                </Grid>
                                <Grid xs={2} item>
                                    <Button variant="outlined" color="primary" href={"/api/FileUploadDownload/DownloadFileId/" + btoa(localStorage.getItem("authtoken")) + "/" + fileMQ}
                                        download={fileMQName} fullWidth disabled={fileMQ === "" ? true : false} style={{ textAlign: "center", height: 62 }}>
                                        MONITORING QUESTIONS
                                </Button>
                                </Grid>
                                <Grid xs={1} item>
                                    <Button variant="outlined" color="primary" href={"/api/FileUploadDownload/DownloadFileIdWordAsPDF/" + btoa(localStorage.getItem("authtoken")) + "/" + fileMQ}
                                        download={fileMQPDF} fullWidth disabled={fileMQ === "" ? true : false}>
                                        PDF
                                </Button>
                                </Grid>
                                <Grid xs={2} item>
                                    <Button variant="outlined" color="primary" href={"/api/FileUploadDownload/DownloadFileId/" + btoa(localStorage.getItem("authtoken")) + "/" + fileNS}
                                        download={fileNSName} fullWidth disabled={fileNS === "" ? true : false} style={{ textAlign: "center", height: 62 }}>
                                        MONITORING NOTE FOR SUPPLY
                                </Button>
                                </Grid>
                                <Grid xs={1} item>
                                    <Button variant="outlined" color="primary" href={"/api/FileUploadDownload/DownloadFileIdWordAsPDF/" + btoa(localStorage.getItem("authtoken")) + "/" + fileNS}
                                        download={fileNSPDF} fullWidth disabled={fileNS === "" ? true : false}>
                                        PDF
                                </Button>
                                </Grid>
                                <Grid xs={2} item>
                                    <Button variant="outlined" color="primary" href={"/api/FileUploadDownload/DownloadFileId/" + btoa(localStorage.getItem("authtoken")) + "/" + fileNW}
                                        download={fileNWName} fullWidth disabled={fileNW === "" ? true : false} style={{ textAlign: "center", height: 62 }}>
                                        MONITORING NOTE FOR WORKS
                                </Button>
                                </Grid>
                                <Grid xs={1} item>
                                    <Button variant="outlined" color="primary" href={"/api/FileUploadDownload/DownloadFileIdWordAsPDF/" + btoa(localStorage.getItem("authtoken")) + "/" + fileNW}
                                        download={fileNWPDF} fullWidth disabled={fileNW === "" ? true : false}>
                                        PDF
                                </Button>
                                </Grid>
                                <Grid xs={2} item>
                                    <Button variant="outlined" color="primary" href={"/api/FileUploadDownload/DownloadFileId/" + btoa(localStorage.getItem("authtoken")) + "/" + fileRS}
                                        download={fileRSName} fullWidth disabled={fileRS === "" ? true : false} style={{ textAlign: "center", height: 62 }}>
                                        RESPONSE SHEET
                                </Button>
                                </Grid>

                                {
                                    //<Grid xs={1} item>
                                    //    <Button variant="outlined" color="primary" href={"/api/FileUploadDownload/DownloadFileIdWordAsPDF/" + btoa(localStorage.getItem("authtoken")) + "/" + fileRS}
                                    //        download={fileRSPDF} fullWidth disabled={fileRS === "" ? true : false}>
                                    //        PDF
                                    //    </Button>
                                    //</Grid>
                                }

                            </Grid>
                            {
                                //<p>FileMR: {fileMR}</p>
                                //<p>FileMQ: {fileMQ}</p>
                                //<p>FileNS: {fileNS}</p>
                                //<p>FileNW: {fileNW}</p>
                                //<p>FileRS: {fileRS}</p>
                                //<p>Additional: {fileAdditional}</p>
                            }
                        </div >
                    );
                } else {

                    //if (userType !== 2 && pageLastRevision !== 10) {

                    //    console.log("pageLastRevision " + pageLastRevision);

                    //    return (
                    //        <p>ROM review is still ongoing.</p>
                    //    );
                    //}

                    return (
                        <Grid container spacing={3}>
                            <Grid>
                                <ToastContainer />
                            </Grid>

                            {
                                <Grid item xs={12}>
                                    <p>Project Title: {this.state.pageMissionDetails[0] != undefined ? this.state.pageMissionDetails[0].ProjectTitle : ""}</p>
                                    <p>Project Number: {this.state.pageMissionDetails[0] != undefined ? this.state.pageMissionDetails[0].ProjectNumber : ""}</p>
                                    <p>Mission Number: {this.state.pageMissionDetails[0] != undefined ? this.state.pageMissionDetails[0].MissionNumber : ""}</p>
                                </Grid>
                            }

                            {
                                //<Grid item xs={12}>
                                //    <div style={{ maxWidth: '100%' }}>
                                //        <MaterialTable
                                //            columns={[
                                //                //{ title: 'Project Id', field: 'idProjectDetails', hidden: true },
                                //                { title: 'Template Number', field: 'TemplateNumber', hidden: true },
                                //                { title: 'Template Name', field: 'TemplateName' },
                                //                //{ title: 'Project Number', field: 'ProjectNumber' },
                                //            ]}
                                //            data={this.state.templateList}
                                //            title="Projects"
                                //            actions={[
                                //                {
                                //                    icon: 'info',
                                //                    tooltip: 'Fill Template',
                                //                    onClick: (event, rowData) => {
                                //                        //this.props.history.push(`/projectdetails/${rowData.idProjectDetails}`);
                                //                    },
                                //                },
                                //            ]}
                                //            options={{
                                //                actionsColumnIndex: -1
                                //            }}
                                //        />
                                //    </div>
                                //</Grid>
                            }

                            {
                                //!this.state.waiting & !this.state.loading ?
                                //true ?
                                pageLastRevision != 10 ?

                                    userType === 2 ?

                                        <Grid item xs={12} className="mt-2">
                                            <Card>
                                                <CardHeader title={"Send Final Version Revision"} className='romis-card-header' />
                                                <CardContent>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={3}>
                                                            <input
                                                                style={{ display: "none" }}
                                                                id="contained-button-file-mq"
                                                                name="fileMQ"
                                                                multiple
                                                                type="file"
                                                                onChange={this.handleFileInputChange.bind(this)}
                                                            />
                                                            <label htmlFor="contained-button-file-mq" style={{ width: "100%" }}>
                                                                <Button
                                                                    variant="outlined"
                                                                    color="primary"
                                                                    size="large"
                                                                    component="span"
                                                                    fullWidth
                                                                    startIcon={<AttachFileIcon />}
                                                                    // disabled={!isFetching & fileMQ !== "" ? false : true}
                                                                    disabled={!isFetching & (fileMQ !== "" || fileMR !== "" ? false : true)}
                                                                >
                                                                    MQ UPLOAD
                                                                </Button>
                                                            </label>
                                                            <Typography
                                                                variant="caption"
                                                                component="h2"
                                                                style={{
                                                                    display: "none" ? filelabelnameMQ === "" : "block"
                                                                }}
                                                            >
                                                                {filelabelnameMQ}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={3}>
                                                            <input
                                                                style={{ display: "none" }}
                                                                id="contained-button-file-mr"
                                                                name="fileMR"
                                                                multiple
                                                                type="file"
                                                                onChange={this.handleFileInputChange.bind(this)}
                                                            />
                                                            <label htmlFor="contained-button-file-mr" style={{ width: "100%" }}>
                                                                <Button
                                                                    variant="outlined"
                                                                    color="primary"
                                                                    size="large"
                                                                    component="span"
                                                                    fullWidth
                                                                    startIcon={<AttachFileIcon />}
                                                                    // disabled={!isFetching & fileMR !== "" ? false : true} 
                                                                    disabled={!isFetching & (fileMQ !== "" || fileMR !== "" ? false : true)}
                                                                >
                                                                    MR UPLOAD
                                                            </Button>
                                                            </label>
                                                            <Typography
                                                                variant="caption"
                                                                component="h2"
                                                                style={{
                                                                    display: "none" ? filelabelnameMR === "" : "block"
                                                                }}
                                                            >
                                                                {filelabelnameMR}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={3}>
                                                            <input
                                                                style={{ display: "none" }}
                                                                id="contained-button-file-ns"
                                                                name="fileNS"
                                                                multiple
                                                                type="file"
                                                                onChange={this.handleFileInputChange.bind(this)}
                                                            />
                                                            <label htmlFor="contained-button-file-ns" style={{ width: "100%" }}>
                                                                <Button
                                                                    variant="outlined"
                                                                    color="primary"
                                                                    size="large"
                                                                    component="span"
                                                                    fullWidth
                                                                    startIcon={<AttachFileIcon />}
                                                                    disabled={!isFetching & fileNS !== "" ? false : true}
                                                                >
                                                                    NS UPLOAD
                                                        </Button>
                                                            </label>
                                                            <Typography
                                                                variant="caption"
                                                                component="h2"
                                                                style={{
                                                                    display: "none" ? filelabelnameNS === "" : "block"
                                                                }}
                                                            >
                                                                {filelabelnameNS}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={3}>
                                                            <input
                                                                style={{ display: "none" }}
                                                                id="contained-button-file-nw"
                                                                name="fileNW"
                                                                multiple
                                                                type="file"
                                                                onChange={this.handleFileInputChange.bind(this)}
                                                            />
                                                            <label htmlFor="contained-button-file-nw" style={{ width: "100%" }}>
                                                                <Button
                                                                    variant="outlined"
                                                                    color="primary"
                                                                    size="large"
                                                                    component="span"
                                                                    fullWidth
                                                                    startIcon={<AttachFileIcon />}
                                                                    disabled={!isFetching & fileNW !== "" ? false : true}
                                                                >
                                                                    NW UPLOAD
                                                            </Button>
                                                            </label>
                                                            <Typography
                                                                variant="caption"
                                                                component="h2"
                                                                style={{
                                                                    display: "none" ? filelabelnameNW === "" : "block"
                                                                }}
                                                            >
                                                                {filelabelnameNW}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={3}>
                                                            <input
                                                                style={{ display: "none" }}
                                                                id="contained-button-file-rs"
                                                                name="fileRS"
                                                                multiple
                                                                type="file"
                                                                onChange={this.handleFileInputChange.bind(this)}
                                                            />
                                                            <label htmlFor="contained-button-file-rs" style={{ width: "100%" }}>
                                                                <Button
                                                                    variant="outlined"
                                                                    color="primary"
                                                                    size="large"
                                                                    component="span"
                                                                    fullWidth
                                                                    startIcon={<AttachFileIcon />}
                                                                    //disabled={!isFetching & fileRS !== "" ? false : true}
                                                                    disabled={!isFetching ? false : true}
                                                                >
                                                                    RS UPLOAD
                                                            </Button>
                                                            </label>
                                                            <Typography
                                                                variant="caption"
                                                                component="h2"
                                                                style={{
                                                                    display: "none" ? filelabelnameRS === "" : "block"
                                                                }}
                                                            >
                                                                {filelabelnameRS}
                                                            </Typography>
                                                        </Grid>

                                                    </Grid>
                                                    <Grid container spacing={6} className="mt-1">
                                                        <Grid item xs={12}>
                                                            <Button variant="outlined" color="primary"
                                                                onClick={this.sendRevision.bind(this)} fullWidth
                                                                disabled={isFetching ? true : false}>
                                                                <AutorenewIcon style={{ paddingRight: "8px" }} />
                                                                {"Send Final Version"}
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        </Grid>

                                        : // This is for if-then-else's else clause

                                        <p>ROM review is still ongoing.</p>

                                    : // This is for if-then-else's else clause

                                    <Grid item xs={12} className="mt-2">
                                        {userType === 2 ? <p>Final version revision sent. Now, please fill in the templates below.</p> : <p>You may download the ROM Reports below.</p>}
                                        <Grid container className="mt-1" spacing={3} >
                                            <Grid xs={2} item>
                                                <Button variant="outlined" color="primary" href={"/api/FileUploadDownload/DownloadFileId/" + btoa(localStorage.getItem("authtoken")) + "/" + fileMR}
                                                    download={fileMRName} fullWidth disabled={fileMR === "" ? true : false}>
                                                    MONITORING REPORT
                                            </Button>
                                            </Grid>
                                            <Grid xs={1} item>
                                                <Button variant="outlined" color="primary" href={"/api/FileUploadDownload/DownloadFileIdWordAsPDF/" + btoa(localStorage.getItem("authtoken")) + "/" + fileMR}
                                                    download={fileMRPDF} fullWidth disabled={fileMR === "" ? true : false}>
                                                    PDF
                                            </Button>
                                            </Grid>
                                            <Grid xs={2} item>
                                                <Button variant="outlined" color="primary" href={"/api/FileUploadDownload/DownloadFileId/" + btoa(localStorage.getItem("authtoken")) + "/" + fileMQ}
                                                    download={fileMQName} fullWidth disabled={fileMQ === "" ? true : false}>
                                                    MONITORING QUESTIONS
                                            </Button>
                                            </Grid>
                                            <Grid xs={1} item>
                                                <Button variant="outlined" color="primary" href={"/api/FileUploadDownload/DownloadFileIdWordAsPDF/" + btoa(localStorage.getItem("authtoken")) + "/" + fileMQ}
                                                    download={fileMQPDF} fullWidth disabled={fileMQ === "" ? true : false}>
                                                    PDF
                                            </Button>
                                            </Grid>
                                            <Grid xs={2} item>
                                                <Button variant="outlined" color="primary" href={"/api/FileUploadDownload/DownloadFileId/" + btoa(localStorage.getItem("authtoken")) + "/" + fileNS}
                                                    download={fileNSName} fullWidth disabled={fileNS === "" ? true : false}>
                                                    MONITORING NOTE FOR SUPPLY
                                            </Button>
                                            </Grid>
                                            <Grid xs={1} item>
                                                <Button variant="outlined" color="primary" href={"/api/FileUploadDownload/DownloadFileIdWordAsPDF/" + btoa(localStorage.getItem("authtoken")) + "/" + fileNS}
                                                    download={fileNSPDF} fullWidth disabled={fileNS === "" ? true : false}>
                                                    PDF
                                            </Button>
                                            </Grid>
                                            <Grid xs={2} item>
                                                <Button variant="outlined" color="primary" href={"/api/FileUploadDownload/DownloadFileId/" + btoa(localStorage.getItem("authtoken")) + "/" + fileNW}
                                                    download={fileNWName} fullWidth disabled={fileNW === "" ? true : false}>
                                                    MONITORING NOTE FOR WORKS
                                            </Button>
                                            </Grid>
                                            <Grid xs={1} item>
                                                <Button variant="outlined" color="primary" href={"/api/FileUploadDownload/DownloadFileIdWordAsPDF/" + btoa(localStorage.getItem("authtoken")) + "/" + fileNW}
                                                    download={fileNWPDF} fullWidth disabled={fileNW === "" ? true : false}>
                                                    PDF
                                            </Button>
                                            </Grid>
                                            <Grid xs={2} item>
                                                <Button variant="outlined" color="primary" href={"/api/FileUploadDownload/DownloadFileId/" + btoa(localStorage.getItem("authtoken")) + "/" + fileRS}
                                                    download={fileRSName} fullWidth disabled={fileRS === "" ? true : false}>
                                                    RESPONSE SHEET
                                            </Button>
                                            </Grid>
                                            {
                                                //<Grid xs={1} item>
                                                //    <Button variant="outlined" color="primary" href={"/api/FileUploadDownload/DownloadFileIdWordAsPDF/" + btoa(localStorage.getItem("authtoken")) + "/" + fileRS}
                                                //        download={fileRSPDF} fullWidth disabled={fileRS === "" ? true : false}>
                                                //        PDF
                                                //    </Button>
                                                //</Grid>
                                            }
                                        </Grid>
                                    </Grid>


                            }


                            {
                                //<ReportRevisionSend
                                //    title="Revision"
                                //    //actualDate="01/01/20"
                                //    plannedDate={""}
                                //    onChangeCommentText={this.commentOnChange.bind(this)}
                                //    sendRevision={this.sendRevision.bind(this)}
                                //    onChangeMQ={this.handleFileInputChange.bind(this)}
                                //    onChangeMR={this.handleFileInputChange.bind(this)}
                                //    onChangeAdditional={this.handleFileInputChange.bind(this)}
                                //    userRole={userListAndRoleMission}
                                //    countOfRevision={countOfRevision}
                                //    isFetching={isFetching}
                                //    submittingDate={submittingDate}
                                //    onChangeDate={(name, value) =>
                                //        this.handleChangeDate(name, value)
                                //    }
                                //    postAsUser={postAsUser}
                                //    onPostAsUserChange={this.handlePostAsUserChange.bind(this)}
                                //    userRoleMission={userRoleMission}
                                //    userType={userType}
                                ///>
                            }


                            <Grid item xs={12} style={{ display: userType !== 4 ? "block" : "none" }}>
                                <Autocomplete
                                    options={templateList}
                                    getOptionLabel={option => option.TemplateName}
                                    autoComplete
                                    includeInputInList
                                    onChange={this.handleTemplateChange.bind(this)}
                                    renderInput={params => (
                                        <TextField {...params} label="Template" margin="normal" fullWidth />
                                    )}
                                    value={selectedTemplate}
                                    disabled={pageLastRevision != 10}
                                />
                            </Grid>
                            <Grid item xs={12} style={{ display: userType !== 4 ? "block" : "none" }}>

                                {
                                    this.state.selectedTemplate !== null && this.state.selectedTemplate.TemplateNumber === 1 ?
                                        <O_Mr
                                            propMissionId={this.props.match.params.id}
                                            propTemplateId={this.state.selectedTemplate.TemplateNumber}
                                            propPageLoadData={this.state.pageLoadData_O_Mr}
                                            propUpdatePageLoadData={this.updatePageLoadData_O_Mr.bind(this)}
                                        /> : null
                                }

                                {
                                    this.state.selectedTemplate !== null && this.state.selectedTemplate.TemplateNumber === 2 ?
                                        <E_Mr
                                            propMissionId={this.props.match.params.id}
                                            propTemplateId={this.state.selectedTemplate.TemplateNumber}
                                            propPageLoadData={this.state.pageLoadData_E_Mr}
                                            propUpdatePageLoadData={this.updatePageLoadData_E_Mr.bind(this)}
                                        /> : null
                                }

                                {
                                    this.state.selectedTemplate !== null && this.state.selectedTemplate.TemplateNumber === 3 ?
                                        <O_Mq
                                            propMissionId={this.props.match.params.id}
                                            propTemplateId={this.state.selectedTemplate.TemplateNumber}
                                            propPageLoadData={this.state.pageLoadData_O_Mq}
                                            propUpdatePageLoadData={this.updatePageLoadData_O_Mq.bind(this)}
                                        /> : null
                                }

                                {
                                    this.state.selectedTemplate !== null && this.state.selectedTemplate.TemplateNumber === 4 ?
                                        <E_Mq
                                            propMissionId={this.props.match.params.id}
                                            propTemplateId={this.state.selectedTemplate.TemplateNumber}
                                            propPageLoadData={this.state.pageLoadData_E_Mq}
                                            propUpdatePageLoadData={this.updatePageLoadData_E_Mq.bind(this)}
                                        /> : null
                                }

                                {
                                    this.state.selectedTemplate !== null && this.state.selectedTemplate.TemplateNumber === 5 ?
                                        <O_MonitoringNoteSupplies
                                            propMissionId={this.props.match.params.id}
                                            propTemplateId={this.state.selectedTemplate.TemplateNumber}
                                            propPageLoadData={this.state.pageLoadData_O_MonitoringNoteSupplies}
                                            propUpdatePageLoadData={this.updatePageLoadData_O_MonitoringNoteSupplies.bind(this)}
                                        /> : null
                                }

                                {
                                    this.state.selectedTemplate !== null && this.state.selectedTemplate.TemplateNumber === 6 ?
                                        <E_MonitoringNoteSupply
                                            propMissionId={this.props.match.params.id}
                                            propTemplateId={this.state.selectedTemplate.TemplateNumber}
                                            propPageLoadData={this.state.pageLoadData_E_MonitoringNoteSupply}
                                            propUpdatePageLoadData={this.updatePageLoadData_E_MonitoringNoteSupply.bind(this)}
                                        /> : null
                                }

                                {
                                    this.state.selectedTemplate !== null && this.state.selectedTemplate.TemplateNumber === 7 ?
                                        <O_MonitoringNoteWorks
                                            propMissionId={this.props.match.params.id}
                                            propTemplateId={this.state.selectedTemplate.TemplateNumber}
                                            propPageLoadData={this.state.pageLoadData_O_MonitoringNoteWorks}
                                            propUpdatePageLoadData={this.updatePageLoadData_O_MonitoringNoteWorks.bind(this)}
                                        /> : null
                                }

                                {
                                    this.state.selectedTemplate !== null && this.state.selectedTemplate.TemplateNumber === 8 ?
                                        <E_MonitoringNoteWorks
                                            propMissionId={this.props.match.params.id}
                                            propTemplateId={this.state.selectedTemplate.TemplateNumber}
                                            propPageLoadData={this.state.pageLoadData_E_MonitoringNoteWorks}
                                            propUpdatePageLoadData={this.updatePageLoadData_E_MonitoringNoteWorks.bind(this)}
                                        /> : null
                                }

                            </Grid>
                            <Grid item xs={12} className="mt-1">
                                <Modal show={modalFinishOpen} onHide={() => this.setModalFinishOpenToggle()} centered>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Finish & Close Confirmation</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>Are you sure you want to Finish & Close ?</Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={() => this.handleDoMissionFinish()}>
                                            Confirm
                            </Button>
                                        <Button variant="primary" onClick={() => this.setModalFinishOpenToggle()}>
                                            Cancel
                            </Button>
                                    </Modal.Footer>
                                </Modal>
                            </Grid>
                            <Grid item xs={12} style={{ display: userType !== 4 ? "block" : "none" }}>
                                <Button variant="contained"
                                    color="primary" onClick={this.handleMissionFinishConfirmation.bind(this)}
                                    disabled={pageLastRevision != 10} fullWidth>Finish & Close Mission</Button>
                            </Grid>
                        </Grid>
                    );
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/TemplateFillingPage.js